<template>
  <div class="phone">
    <video
      src="../assets/video/iphone.mp4"
      autoplay
      loop
      muted
      width="280"
    ></video>
    <img src="../assets/img/iphone.png" alt="iPhone" />
  </div>
</template>

<style lang="scss" scoped>
.phone {
  position: relative;
  min-height: 600px;
  min-width: 340px;
  video {
    position: absolute;
    top: 35px;
    left: 31px;
    z-index: -1;
  }

  img {
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: 640px) {
    display: none;
  }

  margin-right: 6em;
}
</style>

<script>
export default {
    name: "PhoneVideo"
}
</script>
